function componentToHex(c) {
  var hex = c.toString(16);
  return hex.length == 1 ? "0" + hex : hex;
}

export function rgbToHex(r, g, b) {
  return "#" + componentToHex(r) + componentToHex(g) + componentToHex(b);
}

export function objToHex(obj) {
  return "#" + componentToHex(obj.r) + componentToHex(obj.g) + componentToHex(obj.b);
}

export function hexToRgb(hex) {
  var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
  return result
    ? {
        r: parseInt(result[1], 16),
        g: parseInt(result[2], 16),
        b: parseInt(result[3], 16),
      }
    : null;
}

export function brightness(r, g, b) {
  return 0.299 * r + 0.587 * g + 0.114 * b;
}

export function complementaryColor(r, g, b) {
  return { r: 255 - r, g: 255 - g, b: 255 - b };
}

export function transformColor(r, g, b, p) {
  // const br = brightness(r, g, b);
  // const diffBr = br * p;
  const newColor = {
    r: Math.min(Math.floor(r * p), 255),
    g: Math.min(Math.floor(g * p), 255),
    b: Math.min(Math.floor(b * p), 255),
  };
  return newColor;
}

export function getDominantColor({ r, g, b }) {
  let dominantColor = "Red";
  if (g > r && g > b) {
    dominantColor = "Green";
  }
  if (b > g && b > r) {
    dominantColor = "Blue";
  }
  if (r === g && g === b) {
    if (r === 0) dominantColor = "Black";
    else if (r === 255) dominantColor = "White";
    else dominantColor = "Gray";
  }
  return dominantColor;
}

export function hslToHex(h, s, l) {
  const hDecimal = l / 100;
  const a = (s * Math.min(hDecimal, 1 - hDecimal)) / 100;
  const f = (n) => {
    const k = (n + h / 30) % 12;
    const color = hDecimal - a * Math.max(Math.min(k - 3, 9 - k, 1), -1);

    // Convert to Hex and prefix with "0" if required
    return Math.round(255 * color)
      .toString(16)
      .padStart(2, "0");
  };
  return `#${f(0)}${f(8)}${f(4)}`;
}

export function hexToHSL(hex) {
  const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);

  if (!result) {
    throw new Error("Could not parse Hex Color");
  }

  const rHex = parseInt(result[1], 16);
  const gHex = parseInt(result[2], 16);
  const bHex = parseInt(result[3], 16);

  const r = rHex / 255;
  const g = gHex / 255;
  const b = bHex / 255;

  const max = Math.max(r, g, b);
  const min = Math.min(r, g, b);

  let h = (max + min) / 2;
  let s = h;
  let l = h;

  if (max === min) {
    // Achromatic
    return { h: 0, s: 0, l };
  }

  const d = max - min;
  s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
  switch (max) {
    case r:
      h = (g - b) / d + (g < b ? 6 : 0);
      break;
    case g:
      h = (b - r) / d + 2;
      break;
    case b:
      h = (r - g) / d + 4;
      break;
  }
  h /= 6;

  s = s * 100;
  s = Math.round(s);
  l = l * 100;
  l = Math.round(l);
  h = Math.round(360 * h);

  return { h, s, l };
}

export function hslToRGB(h, s, l) {
  const hDecimal = h / 100;
  const sDecimal = s / 100;
  const lDecimal = l / 100;

  let r, g, b;

  if (s === 0) {
    return { r: lDecimal, g: lDecimal, b: lDecimal };
  }

  const HueToRGB = (p, q, t) => {
    if (t < 0) t += 1;
    if (t > 1) t -= 1;
    if (t < 1 / 6) return p + (q - p) * 6 * t;
    if (t < 1 / 2) return q;
    if (t < 2 / 3) return p + (q - p) * (2 / 3 - t) * 6;
    return p;
  };

  let q = lDecimal < 0.5 ? lDecimal * (1 + sDecimal) : lDecimal + sDecimal - lDecimal * sDecimal;
  let p = 2 * lDecimal - q;

  r = HueToRGB(p, q, hDecimal + 1 / 3);
  g = HueToRGB(p, q, hDecimal);
  b = HueToRGB(p, q, hDecimal - 1 / 3);

  return { r: r * 255, g: g * 255, b: b * 255 };
}

export function rgbToHSL(r, g, b) {
  const rl = r / 255.0;
  const gl = g / 255.0;
  const bl = b / 255.0;

  let max = Math.max(rl, gl, bl);
  let min = Math.min(rl, gl, bl);

  let h = (max + min) / 2;
  let s = h;
  let l = h;

  if (max === min) {
    // Achromatic
    return { h: 0, s: 0, l: l * 100 };
  }

  const d = max - min;
  s = l >= 0.5 ? d / (2 - (max + min)) : d / (max + min);
  switch (max) {
    case rl:
      h = ((gl - bl) / d + 0) * 60;
      break;
    case gl:
      h = ((bl - rl) / d + 2) * 60;
      break;
    case bl:
      h = ((rl - gl) / d + 4) * 60;
      break;
  }

  return { h: Math.round(h), s: Math.round(s * 100), l: Math.round(l * 100) };
}
